var exports = {
  "kL": "x127c5a35--558f69--container",
  "_8": "x127c5a35--558f69--img",
  "DD": "x127c5a35--558f69--title",
};

module.exports = exports;
